import type {ReactNode} from "react";

type ImagePickerAddTileProps = {
  label: string;
  icon: ReactNode;
  onClick?: () => void;
  onPointerDown?: (event: React.PointerEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  "aria-label"?: string;
};

/** Dashed add tile — must stay in normal sheet DOM (not a portaled popover) for getUserMedia. */
export function ImagePickerAddTile({
  label,
  icon,
  onClick,
  onPointerDown,
  disabled,
  "aria-label": ariaLabel,
}: ImagePickerAddTileProps) {
  return (
    <button
      type="button"
      disabled={disabled}
      aria-label={ariaLabel ?? label}
      onPointerDown={onPointerDown}
      onClick={onClick}
      className="flex h-24 w-24 flex-col items-center justify-center rounded-md border-2 border-dashed border-border hover:bg-muted/50 disabled:opacity-50"
    >
      {icon}
      <p className="mt-1 text-xs text-muted-foreground">{label}</p>
    </button>
  );
}
